// frontend/src/components/ProtectedRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkOrRenewToken, authStatus } from '../services/AuthService';
import { useAuth } from '../services/AuthContext';
import PaywallScreen from './PaywallScreen';

// requireSubscription : quand true, la route n'est accessible qu'aux utilisateurs
// ayant un abonnement actif (expireDate futur) ou admin. C'est le cas des écrans
// Note et Besoin, qui sont des fonctionnalités payantes.
const ProtectedRoute = ({ element, requireSubscription = false }) => {
  const [authLoadStatus, setAuthLoadStatus] = useState('loading'); // 'loading' | 'valid' | 'unauthenticated'
  const { authLoading, hasActiveSubscription } = useAuth();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const result = await checkOrRenewToken();
        setAuthLoadStatus(result.status === authStatus.VALID ? 'valid' : 'unauthenticated');
      } catch (err) {
        console.error("Erreur vérification token:", err);
        setAuthLoadStatus('unauthenticated');
      }
    };

    verifyAuth();
  }, []);

  // Tant que le token ET le rôle/abonnement (via AuthContext) ne sont pas résolus,
  // on affiche un état de chargement plutôt que de rediriger/bloquer trop tôt.
  if (authLoadStatus === 'loading' || (requireSubscription && authLoading)) {
    return <div>Chargement...</div>;
  }

  if (authLoadStatus !== 'valid') {
    return <Navigate to="/" />;
  }

  if (requireSubscription && !hasActiveSubscription) {
    return <PaywallScreen />;
  }

  return element;
};

export default ProtectedRoute;